<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 军校招生 -->
    <div class="military_school studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">什么是小语种？</h6>
            <div class="main_box">
                <p>小语种，是指除联合国通用语种（汉语、英语、法语、西班牙语、俄语、阿拉伯语）外的语种。小语种招考是指专门针对这些外国语言种类的高等教育学校专业选拔方式。由于小语种对学生的素质有特殊要求，所以对口语考试有成绩要求。</p>
            </div>    
        </div>
        <div class="benefit main">
            <h6 class="main_title">报考条件</h6>
            <div class="main_box">
                <p>(1) 口语考试成绩合格。</p>
                <p>(2) 高考成绩达到相应院校分数线。</p>
            </div>
        </div>
        <div class="benefit main">
            <h6 class="main_title">招生方式</h6>
            <div class="main_box"><p>目前，小语种的招生方式大致有两种：</p></div>
            <div class="main_box">
                <p>(1) 本科提前批次录取<br/>其报考方式与其他提前批次录取的专业没有区别。如北京大学、中国人民大学、对外经济贸易大学、中国传媒大学、外交学院的小语种专业，在北京招生时一般放在提前批次录取。考生只需填报提前批次的相应志愿即可。</p>
                <p>(2) 除本科提前批次外的本科其他批次录取<br/>如北京语言大学、中央民族大学、中国政法大学、首都师范大学、上海外国语大学、南京大学、四川大学、中南财经政法大学等高校在本科一批招收小语种专业；部分如天津外国语大学、天津师范大学、大连外国语学院、济南大学等院校小语种专业在本科二批招生。</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {}
    },
    methods: {},
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .military_school {
        .liucheng {
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    text-align: center;
                    line-height: 50px;
                    /* width: 189px; */
                    height: 50px;
                    /* padding-right: 60px; */
                    background: url(/imgs/wayToStudy/common/icon_liucheng.png) no-repeat right center;
                    margin-right: 20px;
                    padding-right: 53px;
                    background-size: 20px 20px;
                    // &:last-child {
                    //     padding-right: 0px;
                    // }
                }
            }
        }
        .universities  ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
            }
    }
        
    }
    
</style>